var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list__item",class:_vm.listItemClass},[(_vm.$slots.key)?_c('span',{staticClass:"list__item-key"},[_vm._t("key")],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"list__item-value"},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }